// This page is actually implemented in Library/Std/Tag.md
export const tagPrefix = "tag:";
